import React from 'react';
import { jwtDecode } from 'jwt-decode';
import NotAuthorized from '../src/Components/NotAuthorised/NotAuthorised';
import NotAuthorizedExternal from '../src/Components/NotAuthorised/NotAuthorisedExternal';

const getUserRoles = () => {
  const token = localStorage.getItem(process.env.REACT_APP_CIAM_ACCESS_KEY);
  if (!token) return [];
  try {
    const decoded = jwtDecode(token);
    let roles = decoded?.roles || [];
    if (typeof roles === 'string') {
      roles = roles.split(',').map(r => r.trim());
    }
    return roles.map(r => r.toLowerCase());
  } catch (error) {
    console.error('Invalid token', error);
    return [];
  }
};

const allAllowedRoles = [
  'idamaerskcx',
  'maerskinternal',
  'idavestasapprover',
  'idavestasviewer',
  'idamaerskbilling',
  'idamaerskviewer'
];

const ProtectedRoute = ({ children, allowedRoles }) => {
  const userRoles = getUserRoles();
  const allowed = allowedRoles.map(r => r.toLowerCase());

  // External user or BasicSoftUser check
  if (
    userRoles.includes('basicsoftuser') ||
    !userRoles.some(role => allAllowedRoles.includes(role))
  ) {
    return <NotAuthorizedExternal />;
  }

  // Internal access check
  const isAuthorized = userRoles.some(role => allowed.includes(role));

  if (!isAuthorized) {
    return <NotAuthorized />;
  }

  return children;
};

export default ProtectedRoute;
